type ServiceEngagement = {
  description: string
  title: string
}

type ServiceEngagementStripProps = {
  engagements: ServiceEngagement[]
}

export function ServiceEngagementStrip({ engagements }: ServiceEngagementStripProps) {
  return (
    <section aria-label="Engagement options" className="mt-10 rounded-lg border border-white/10 bg-card/70">
      <div className="grid divide-y divide-white/8 md:grid-cols-3 md:divide-x md:divide-y-0">
        {engagements.map((engagement) => (
          <article key={engagement.title} className="p-5">
            <h2 className="text-base font-semibold text-phosphor-ivory">{engagement.title}</h2>
            <p className="mt-3 text-sm leading-7 text-white/62">{engagement.description}</p>
          </article>
        ))}
      </div>
    </section>
  )
}
